const topics = new Map()

let i = 0

function fire (topic, data) {
  if (!topics.has(topic)) return
  const subs = topics.get(topic)
  if (!subs.size) return
  subs.forEach(cb => cb(data))
}

function sub (topic, cb) {
  if (!topic) throw new Error('no topic specified')
  if (!cb) throw new Error('no callback specified')
  // creating topic if not exists
  if (!topics.has(topic)) topics.set(topic, new Map())
  const idx = ++i
  // saving callback
  topics.get(topic).set(idx, cb)
  return { topic, idx }
}

function unsub ({ topic, idx }) {
  if (!topic) throw new Error('no topic specified')
  if (!idx) throw new Error('no idx specified')
  if (!topics.has(topic)) throw new Error('unknown topic')
  const subs = topics.get(topic)
  if (!subs.has(idx)) throw new Error('unknown subscription')
  subs.delete(idx)
}

module.exports = { fire, sub, unsub }
